<template>
    <div>
        <b-breadcrumb :items="items" />
        <div class="container-fluid" style="background-color: white">
            <br>
            <div class="text-center">
                <h2>บันทึกค่าเที่ยว</h2>
            </div>
            <br/>
            <div class="row text-left">
                <div class="col-sm-6">
                    <span><b>ชื่อ</b> : {{driver.first_name}}</span>
                    <br/>
                    <span><b>นามสกุล</b> : {{driver.last_name}}</span>
                    <br/>
                    <span>
                    <b>เบอร์โทรศัพท์</b> :<span> {{driver.phone}} {{driver.phone2}} {{driver.phone3}}</span>
                        <br>-
                    <b>เด็กรถคนที่ 1</b> :<span> {{driver.name_henchman_1}}</span>
                        <br>
                    <b>เด็กรถคนที่ 2</b> :<span> {{driver.name_henchman_2}}</span>
                        <br>
                    <b>เด็กรถคนที่ 3</b> :<span> {{driver.name_henchman_3}}</span>
                </span>
                </div>
                <div class="col-sm-6">
                    <span><b>ทะเบียนรถ</b> : {{driver.license_plate}}</span>
                    <br/>
                    <span v-if="driver.transport_type"><b>ทะเบียนรถ</b> : {{driver.transport_type.name}}</span>
                    <br/>
                    <span><b>เงินฝากสะสม</b> : {{driver.deposit_total ? driver.deposit_total : 0 | currency}}</span>
                    <br/>
                    <span><b>ค่าผ่อนรถสะสม</b> : {{driver.sum_car_fee ? driver.sum_car_fee : 0 |currency }}</span>
                    <br/>
                    <span><b>ค่าผ่อนหลังคาสะสม</b> : {{driver.sum_car_roof ? driver.sum_car_roof : 0 |currency }}</span>
                    <br/>
                    <span><b>ค่าประกันสะสม</b> : {{driver.insurance_fee_total ? driver.insurance_fee_total : 0 |currency }}</span><br>
                    <span><b>วันหมดอายุ ประกันภัย</b> : {{driver.insurance_date | moment("DD/MM/YYYY") }}</span><br>
                    <span><b>วันหมดอายุ พรบ</b> : {{driver.car_act_date | moment("DD/MM/YYYY")}}</span><br>
                    <span><b>วันหมดอายุ ภาษี</b> : {{driver.tax_date | moment("DD/MM/YYYY")}}</span>
                </div>
            </div>
            <div style="display: none">{{alertExpireDate}}</div>
            <div style="border-radius: 5px; margin: 20px; padding: 20px; font-size: 20px"
                 v-if="expire_insurance"
                 class="alert-danger">
                <icon name="exclamation-triangle"></icon>
                คำเตือน : ประกันภัยหมดอายุแล้ว
            </div>
            <div style="border-radius: 5px; margin: 20px; padding: 20px; font-size: 20px"
                 v-if="expire_act"
                 class="alert-danger">
                <icon name="exclamation-triangle"></icon>
                คำเตือน : พรบ.อายุแล้ว
            </div>
            <div style="border-radius: 5px; margin: 20px; padding: 20px; font-size: 20px"
                 v-if="expire_tax"
                 class="alert-danger">
                <icon name="exclamation-triangle"></icon>
                คำเตือน : ภาษีหมดอายุแล้ว
            </div>
            <br>
            <div style="color: red">**รถเล็กไม่มีเงินฝาก,ค่าประกัน,ค่าผ่อนรถ</div>
            <div style="color: lightseagreen">**รถเล็ก,รถใหญ่ จะมีค่าพ่วงก็ต่อเมื่อไม่ได้ใช้ขนส่ง และ วิ่งบิลมากกว่า 3 บิลขึ้นไป</div>
            <div style="color: lightseagreen">**รถเล็ก,รถใหญ่ หากเที่ยวไหนไปขนส่ง ไม่คิดโบนัสของรอบนั้น</div>
            <div style="color: blue">**รถใหญ่ กรณีไปขนส่งไม่มีค่าประกัน และ ค่าผ่อนรถ</div>
            <div style="color: blue">**รถใหญ่ โบนัสจ่ายเดือนละ 1 ครั้ง วิ่งรถ 12 เที่ยว โบนัส 1000 บาท ,13 เที่ยวขึ้นไป โบนัส 2000 บาท</div>
            <div class="col-sm-12 table-responsive">
                <table class="table table-bordered">
                    <thead>
                    <tr>
                        <th scope="col">รายการ</th>
                        <th scope="col">จำนวน(บาท)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr class="text-left">
                        <td>
                            <p>เลขที่ใบบิล :</p>
                            <template v-for="data in invoice">
                                <input class="form-control col-sm-5" disabled v-model="data.invoice_number"/>
                                <br/>
                            </template>
                        </td>
                        <td>
                            <p> ค่าเที่ยว :</p>
                            <template v-if="invoice.length > 0">
                                <div class="form-inline">
                                    <span>+</span>
                                    <input class="form-control col-sm-6"
                                           type="number"
                                           disabled
                                           v-model="invoice[0].transport_fee"/>
                                </div>
                                <br/>
                            </template>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            ค่าเที่ยวประจำวันที่
                        </td>
                        <td>
                            <b-form inline>
                                <date-picker v-model="form.date"
                                             placeholder="วันที่บันทึกค่าเที่ยว"
                                             class="w-50"
                                             style="padding-left: 10px"
                                             :format="changeFormat"
                                             @input="getBonusDriverByDate"
                                             :lang="lang">
                                </date-picker>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            เวลารถออก
                        </td>
                        <td>
                            <b-form inline>
                                <date-picker v-model="form.time_leave"
                                             type="time"
                                             style="padding-left: 10px"
                                             format="HH:mm"
                                             class="w-50"
                                             placeholder="เวลารถออก">
                                </date-picker>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            ค่าพ่วง
                        </td>
                        <td>
                            <b-form inline>
                                <span>+</span>
                                <input class="form-control col-sm-6"
                                       type="number"
                                       v-model="form.invoice_other_fee"/>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>เงินพิเศษสำหรับคนขับ (โบนัส)</td>
                        <td>
                            <b-form inline>
                                <span>+</span>
                                <input class="form-control col-sm-6"
                                       type="number"
                                       v-model="form.bonus"/>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            ค่าประกัน
                            <span style="color: red" v-if="driver.insurance_fee_status != 1">
                                <template v-if="driver.insurance_status">
                                    (ประกันครบแล้ว)
                                </template>
                                <template v-else>
                                    (*ยังไม่ได้ชำระค่าประกันประจำเดือนนี้)
                                </template>
                            </span>
                        </td>
                        <td>
                            <b-form inline>
                                <span>-</span>
                                <input class="form-control col-sm-6"
                                       type="number"
                                       :disabled="driver.insurance_status"
                                       v-model="form.insurance_fee"/>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            ค่าผ่อนหลังคา
                        </td>
                        <td>
                            <b-form inline>
                                <span>-</span>
                                <input class="form-control col-sm-6"
                                       type="number"
                                       v-model="form.car_roof"/>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>ค่าผ่อนรถ</td>
                        <td>
                            <b-form inline>
                                <span>-</span>
                                <input class="form-control col-sm-6"
                                       type="number"
                                       v-model="form.car_fee"/>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            เงินฝาก
                            <span style="color: red" v-if="driver.deposit_status != 1 && driver.transport_type_id == 1">
                                (* ยังไม่ได้ชำระเงินฝากประจำเดือนนี้)
                            </span>
                        </td>
                        <td>
                            <b-form inline>
                                <span>-</span>
                                <input class="form-control col-sm-6"
                                       type="number"
                                       v-model="form.deposit"/>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>ค่าความเสียหาย
                            <span style="color: red" v-if="driver.damages_total > 0">(*ยอดคงเหลือ {{driver.damages_total | currency }} บาท)</span>
                            <span style="color: red" v-else>(*ยอดคงเหลือ 0 บาท)</span>
                        </td>
                        <td>
                            <b-form inline>
                                <span>-</span>
                                <input class="form-control col-sm-6"
                                       type="number"
                                       v-model="form.damages_fee"/>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>วันที่บันทึกค่าเที่ยว
                        </td>
                        <td>
                            <b-form inline>
                                <span>-</span>
                                <date-picker v-model="form.date_time"
                                             placeholder="วันที่บันทึกค่าเที่ยว"
                                             class="w-50"
                                             type="datetime"
                                             format="DD/MM/YYYY HH:mm:ss"
                                             :lang="lang">
                                </date-picker>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div class="form-check">
                                <input type="checkbox" class="form-check-input"
                                       v-model="form.is_tax"
                                       id="check_tax">
                                <label class="form-check-label" for="check_tax">เก็บภาษีสำหรับ ณ ที่จ่าย {{setting_tax.percent_tax}}%</label>
                            </div>
                        </td>
                        <td>
                            <b-form inline>
                                <span>-</span>
                                <input class="form-control col-sm-6"
                                       type="number"
                                       disabled
                                       v-model="calculateTax"/>
                            </b-form>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b style="font-size: 20px">รวม</b>
                        </td>
                        <td>
                            <span style="font-size: 20px">{{Total | currency }}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col text-center">
                <button @click.once="submitData"
                        :disabled="loading == 1 ? true : false"
                        type="button"
                        class="btn btn-success">
                    <icon name="save" style="width: 25px"></icon>
                    บันทึกและพิมพ์</button>&nbsp;&nbsp;
                <button @click="goToDriverList"
                        type="button"
                        class="btn btn btn-outline-secondary">
                    <icon name="times" style="width: 25px"></icon> ยกเลิก
                </button>
            </div>
            <br/>
            <b-modal hide-header hide-footer ref="loading">
                <loading :msg="msg" :status="status_loading" @submit="hideLoadingModal"></loading>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import moment from "moment";
    import { domain } from "../../../util/Constants";
    import DatePicker from 'vue2-datepicker'
    import Loading from "../../Utility/Loading";
    import {canViewSuperAdmin} from "../../../util/Permissions";
    import ConfirmModal from "../../Utility/ConfirmModal";

    export default {
        name: "driver-shipping",
        props: {
            id: { default: null }
        },
        components:{
            ConfirmModal,
            Loading,
            DatePicker
        },
        data(){
            return{
                expire_tax : false,
                expire_insurance : false,
                expire_act : false,
                percent_tax : 1,
                msg : '',
                status_loading : 1,
                loading : 1,
                items: [
                    {
                        text: "รายการคนขับ",
                        to: { name: "driver" }
                    },
                    {
                        text: "เพิ่มเติม",
                        active: true
                    }
                ],
                changeFormat: {
                    stringify: (date) => {
                        let date_moment = moment(date).format('YYYY');
                        const year = parseInt(date_moment) + 543;
                        return date ? moment(date).format('DD/MM/'+year) : null
                    },
                    parse: (value) => {
                        return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                    }
                },
                lang: {
                    days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                    months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                    pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                    placeholder: {
                        date: 'วว/ดด/ปปปป',
                    }
                },
            }
        },
        created(){
            // this.getBonusDriverByDate();
            this.getSettingTaxData();
        },
        computed:{
            canViewSuperAdmin,
            ...mapState({
                setting_tax : state=>{
                    return state.Driver.setting_tax
                },
                driver :state=>{
                    return state.Driver.form;
                },
                invoice :state=>{
                    return state.DriverDetails.filter_invoice.sort(invoice=>{
                        return invoice.transport_fee
                    })
                },
                insurance_total :state=>{
                    return state.InsuranceFee.insurance_total
                },
                user:state=>{
                    return state.Auth.user;
                },
                form : state=>{
                    return state.DriverDetails.form
                }
            }),
            Total(){
                return this.CalculateTotal() - parseFloat(this.form.tax);
            },
            alertExpireDate(){
                this.expire_tax = false;
                this.expire_insurance = false;
                this.expire_act = false;
                let currentDate = new Date();
                let insurance_date = this.driver.insurance_date ? new Date(this.driver.insurance_date) : null;
                let tax_date = this.driver.tax_date ? new Date(this.driver.tax_date) : null;
                let car_act_date = this.driver.car_act_date ? new Date(this.driver.car_act_date) : null;
                if(insurance_date && currentDate > insurance_date){
                    this.expire_insurance = true;
                }
                if(tax_date && currentDate > tax_date){
                    this.expire_tax = true;
                }
                if(car_act_date && currentDate > car_act_date){
                    this.expire_act = true;
                }
            },
            calculateTax(){
                let transport_fee_total = 0;
                let bonus = 0;
                let invoice_other_transport = 0;
                if(this.form.is_tax){
                    if(this.form.transport_fee_total && this.form.transport_fee_total > 0)  transport_fee_total = this.form.transport_fee_total;
                    if(this.form.bonus && this.form.bonus > 0)  bonus = this.form.bonus;
                    if(this.form.invoice_other_fee && this.form.invoice_other_fee > 0)  invoice_other_transport = this.form.invoice_other_fee;
                }
                let total = parseFloat(transport_fee_total) + parseFloat(bonus) + parseFloat(invoice_other_transport);
                return this.form.tax = parseFloat(total) * parseFloat(this.percent_tax / 100);
            },
        },
        methods:{
            format(value, event) {
                return moment(value).format('YYYY-MM-DD')
            },
            showLoadingModal() {
                this.$refs.loading.show();
            },
            hideLoadingModal() {
                this.$refs.loading.hide();
            },
            submitData(){
                this.form.invoices = [];
                this.invoice.forEach(invoice=>{
                    this.form.invoices.push({
                        invoice_id : invoice.invoice_id,
                        transport_fee : invoice.transport_fee //set transport_fee
                    });
                });
                if(this.driver){
                    this.form.driver_id = this.driver.id;
                }
                if(this.form.date){
                    this.form.date = moment(this.form.date).format("YYYY-MM-DD");
                }
                if(this.form.bonus){
                    this.form.bonus = parseFloat(this.form.bonus);
                }
                if(this.form.insurance_fee){
                    this.form.insurance_fee = parseFloat(this.form.insurance_fee);
                }
                if(this.form.car_fee){
                    this.form.car_fee = parseFloat(this.form.car_fee);
                }
                if(this.form.deposit){
                    this.form.deposit = parseFloat(this.form.deposit);
                }
                if(this.form.damages_fee){
                    this.form.damages_fee = parseFloat(this.form.damages_fee);
                }
                if(!this.driver.damages_total){
                    this.driver.damages_total = 0
                }
                if(this.form.damages_fee > this.driver.damages_total){
                    alert('ยอดค่าเสียหายไม่พอให้ชำระ')
                }
                else{
                    let data = {
                        invoices : this.form.invoices,
                        invoice_other_fee : this.form.invoice_other_fee,
                        bonus:this.form.bonus,
                        insurance_fee:this.form.insurance_fee,
                        car_fee :this.form.car_fee,
                        car_roof :this.form.car_roof,
                        deposit : this.form.deposit,
                        damages_fee : this.form.damages_fee,
                        driver_id : this.form.driver_id,
                        date : this.form.date,
                        time_leave : this.form.time_leave,
                        transport_fee_total : this.form.transport_fee_total,
                        tax : this.form.tax,
                        is_tax : this.form.is_tax,
                        date_time : this.form.date_time ?  moment(this.form.date_time).format("YYYY-MM-DD HH:mm:ss") : '',
                        create_user_id : this.user.id,
                        update_user_id : this.user.id,
                    };
                    this.saveSubmitShippingFee(data);
                }
            },
            printDriverShipping(id){
                if(id){
                    window.open(domain+'/driver-shipping-pdf/'+id ,'_blank')
                }

            },
            getBonusDriverByDate(){
                if(this.form.date){
                    this.form.date = moment(this.form.date).format("YYYY-MM-DD");
                    this.$store.dispatch('DriverDetails/driverShippingMonth',{
                        driver_id : this.driver.id,
                        date : this.form.date,
                        transportation_id :  '',
                        transport_fee :  this.invoice[0].transport_fee,
                    }).then(()=>this.loading = 0)
                }else{
                    this.loading = 0;
                }
            },
            saveSubmitShippingFee(submitData){
                if(this.form.invoices < 1){
                    alert("TN/คนขับนี้ นี้ถูกบันทึกค่าเที่ยวไปเรียบร้อยแล้ว");
                }
                else{
                    this.id = submitData.driver_id;
                    submitData.time_leave = moment(this.form.time_leave).format("HH:mm");
                    if(submitData.invoices.length > 0){
                        //have invoice
                        this.msg = "กำลังบันทึกค่าเที่ยว กรุณารอสักครู่";
                        this.status_loading = 1;
                        this.showLoadingModal();
                        this.$store.dispatch('DriverDetails/save',submitData).then(data =>{
                            this.printDriverShipping(data.id);
                            this.saveBonusDriver(data.id,submitData);
                            this.saveDamageDriver(data.id,submitData);
                            this.saveInsuranceDriver(data.id,submitData);
                            this.saveDepositDriver(data.id,submitData);
                        }).then(()=>{
                            this.$store.dispatch("DriverDetails/showDriverDetailsId",{
                                driver_id : this.driver.id,
                                page : 1,
                            });
                        });
                    }else{
                        //no invoice
                        submitData.invoices = [];
                        this.$store.dispatch('DriverDetails/save',submitData);
                    }
                    this.goToDriverForm();
                }
            },
            goToDriverForm(){
                const id = this.id;
                this.$store.dispatch('DriverDetails/showDriverDetailsId',{
                    driver_id : id,
                    page : 1,
                }).then(()=>{
                    this.$router.push({
                        name : "driver-form",
                        params : {id}
                    })
                });
            },
            goToDriverList(){
                this.$router.push({
                    name : "driver"
                })
            },
            CalculateTotal(){
                let bonus = 0;
                let insurance = 0;
                let car_fee = 0;
                let car_roof = 0;
                let deposit = 0;
                let damages = 0;
                let other_fee = 0;
                this.form.transport_fee_total = 0;
                if(this.invoice.length > 0){
                    this.form.transport_fee_total = this.invoice[0].transport_fee;
                }
                if(this.form.invoice_other_fee){
                    other_fee = parseFloat(this.form.invoice_other_fee);
                }
                if(this.form.bonus){
                    bonus = parseFloat(this.form.bonus);
                }
                if(this.form.insurance_fee){
                    insurance = parseFloat(this.form.insurance_fee);
                }
                if(this.form.car_fee){
                    car_fee = parseFloat(this.form.car_fee);
                }
                if(this.form.car_roof){
                    car_roof = parseFloat(this.form.car_roof);
                }
                if(this.form.deposit){
                    deposit = parseFloat(this.form.deposit);
                }
                if(this.form.damages_fee){
                    damages = parseFloat(this.form.damages_fee);
                }

                let result = parseFloat(bonus) + parseFloat(other_fee) + parseFloat(this.form.transport_fee_total)
                    - parseFloat(insurance) - parseFloat(car_fee) - parseFloat(car_roof)
                    - parseFloat(deposit) - parseFloat(damages);
                return result;
            },
            saveInsuranceDriver(id,submitData){
                //บันทึกค่าประกัน
                if(submitData.insurance_fee){
                    if(submitData.insurance_fee){
                        const insurance = {
                            driver_id : submitData.driver_id,
                            driver_detail_id : id,
                            date : submitData.date,
                            status_id : 2,
                            insurance_fee_total : this.insurance_total,
                            amount : submitData.insurance_fee,
                            recipient : this.user.name
                        };
                        this.$store.dispatch('InsuranceFee/save',insurance)
                    }
                }
            },
            saveDamageDriver(id,submitData){
                //บันทึกค่าเสียหาย
                if(submitData.damages_fee){
                    const damges = {
                        driver_id : submitData.driver_id,
                        driver_detail_id : id,
                        amount : submitData.damages_fee,
                        date : submitData.date,
                        recipient : this.user.name
                    };
                    this.$store.dispatch('Damages/saveAmountDamages',damges);
                }
            },
            saveDepositDriver(id,submitData){
                //บันทึกเงินฝาก
                if(submitData.deposit){
                    const deposit = {
                        driver_id : submitData.driver_id,
                        driver_detail_id : id,
                        deposit : submitData.deposit,
                        withdraw : 0,
                        date : submitData.date,
                        recipient : this.user.name,
                    };
                    this.$store.dispatch('Deposit/save',deposit);
                }
            },
            saveBonusDriver(id,submitData){
                // บันทึกโบนัสคนขับ
                if(submitData.bonus){
                    const driver_bonus = {
                        driver_id : submitData.driver_id,
                        driver_detail_id : id,
                        amount : submitData.bonus,
                        status : 1,
                        date : submitData.date,
                    };
                    this.$store.dispatch('DriverBonus/save',{
                        id:"",
                        data:driver_bonus
                    });
                }
            },
            getSettingTaxData(){
                this.$store.dispatch("Driver/getSettingTax").then(()=>{
                    this.form.is_tax = this.setting_tax.is_auto;
                    this.percent_tax = this.setting_tax.percent_tax;
                    this.getBonusDriverByDate();
                });
            },
        }
    }
</script>

<style scoped>

</style>
